import { Field, FormProps } from 'redux-form';
import { colors, fonts, mixins } from 'consumer-components';
import { Link } from 'react-router';
import { css, StyleSheet } from 'aphrodite';
import * as cookie from 'react-cookie';
import * as React from 'react';

import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import States from 'login-constants/states';
import Success from 'login-components/Common/Notifications/Success/Success';
import { paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';

const styles = StyleSheet.create({
  resetLink: {
    ...fonts.Roboto,
    textAlign: 'right',
    fontSize: 13,
    display: 'inline-block',
    marginBottom: 5,
    color: colors.clayPlus3,
  },
  notificationsWrapper: {
    marginTop: '5px',
    textAlign: 'left',
  },
  label: {
    ...mixins.padding(30, 10, 10, 10),
  },
});

interface FormBodyProps extends FormProps<any, any, any> {
  successMsg?: string | false | null;
  errorMsg?: string;
  showForgotPassword: boolean;
  errorId: string;
  inputs: FormInput[];
}

export default class FormBody extends React.Component<FormBodyProps, {}> {
  render() {
    // Need to pass up a CSRF token as part of this bad boy.
    const csrfToken = cookie.load('XSRF-TOKEN');
    const { inputs, errorId, errorMsg, successMsg, showForgotPassword } = this.props;
    return (
      <div>
        <input type="hidden" name="_csrf" value={csrfToken} />
        <fieldset>
          {inputs.map((input, index) => (
            <div key={index} className={css(paneFormStyles.fieldWrapper)}>
              <Field {...input} className={css(styles.label)} hidePlaceholder={true} />
            </div>
          ))}
        </fieldset>
        <div>
          {showForgotPassword && (
            <Link className={css(styles.resetLink)} id="it-ResetPasswordLink" to={States.REQUEST_RESET_PASSWORD}>
              Trouble signing in?
            </Link>
          )}
          <div className={css(styles.notificationsWrapper)}>
            <div className={css(paneFormStyles.errorWrapper)}>
              {errorMsg && <ErrorMessage errorId={errorId} errorText={errorMsg} />}
            </div>
            {successMsg && <Success successText={successMsg} successId="it-LoginSuccess" />}
          </div>
        </div>
      </div>
    );
  }
}
